<template>
  <div v-loading="loading" element-loading-text="数据加载中..." style="height: 100%;width: 100%">
    <el-container style="height: 100%;width: 100%">
      <div style="width:100%;height: 100%;margin-left: 2px;overflow-x: hidden;overflow-y: hidden">
        <!--      头部数据-->
        <el-row style="height: 37px;overflow-y: auto;" class="border center">
          <el-col :span="24">
            <div style="text-align: left;">
              <el-button size="small" class="week" style="margin-left: 20px" @click="clickThisWeek">{{ $t('makeSchedule.paintingProductionScheduling.thisWeek') }}</el-button>
              <el-button size="small" class="week" style="margin-left: 30px" @click="clickLastWeek">
                <el-icon>
                  <ElIconArrowLeft/>
                </el-icon>
                {{ $t('makeSchedule.paintingProductionScheduling.lastWeek') }}
              </el-button>
              <el-date-picker size="small" v-model="week" format="M月-D日" value-format="MM-DD" type="daterange"
                              disabled
                              range-separator="~" style="width: 180px;"/>
              <el-button size="small" class="week" @click="clickNextWeek">{{ $t('makeSchedule.paintingProductionScheduling.afterWeek') }}
                <el-icon>
                  <ElIconArrowRight/>
                </el-icon>
              </el-button>
              <span style="margin-left: 20px">
              <span style="background-color: rgb(103, 194, 58);margin-left: 10px">&nbsp;&nbsp;</span> <span>:正常</span>
              <span style="margin-left: 10px;background-color: red">&nbsp;&nbsp;</span> <span>:缺料</span>
              <span style="margin-left: 10px;color: #67c23a;">{{ $t('makeSchedule.AssemblyProductionScheduling.todayProduction') }}</span>/
              <span style="color: #f56c6c;">{{ $t('makeSchedule.AssemblyProductionScheduling.todayProductionScheduling') }}</span>/
              <span style="color: black;">{{ $t('makeSchedule.AssemblyProductionScheduling.yesterday') }}</span>/
              <span style="color: #909399;">{{ $t('makeSchedule.AssemblyProductionScheduling.batchNo') }}</span>
                </span>

              <el-button size="small" :loading="loading1" type="warning" style="margin-left: 20px" @click="exportData">导出</el-button>
            </div>
          </el-col>
        </el-row>
        <!--      有数据-->
        <div ref="total_height" v-if="dataList.length > 0" style="height: 95%;width: 100%;overflow-x: auto;overflow-y: hidden" id="dynamicDiv">
          <!--        物件名称/日期-->
          <div style="display: flex;margin-top: 5px;text-align: center;">
            <el-row class="border color">
              <el-col :span="24" style="height: 44px;line-height:44px;width: 200px;">
                <span>物件</span>
                <span style="margin-left: 30px;">/</span>
                <span style="margin-left: 30px">日期</span>
              </el-col>
            </el-row>
            <div v-for="calendar in calendarLineList" :key="calendar">
              <div style="width: 224px;margin-left: 3px" class="border color">
                <div>{{ calendar.time }}</div>
                <div>{{ calendar.week }}</div>
              </div>
            </div>
          </div>

          <!--        计划面积-->
          <div style="height: 91%;overflow-y: auto;overflow-x: hidden;width: 100%" id="dynamicDiv1">
            <div v-for="(fromData,index1) in dataList" :key="fromData.wujianId" style="display: flex;">
              <div style="text-align: center;margin-top: 5px;width: 204px;" :style="maxLineHeight[index1]"  ref="class_name" :class="fromData.class_name">
                <div style="color:whitesmoke;font-size: 16px">{{
                    fromData.wujianId
                  }}&nbsp;-&nbsp;{{ fromData.wujian_short_name }}
                </div>
                <div style="margin-top: 1px;width: 205px;height: 34px;line-height: 34px;text-align: center;margin-left: -3px" :class="fromData.class_name">
                  <div class="plan_area" style="width: 207px;">
                    计划面积
                  </div>
                </div>
              </div>

              <div v-for="(item,index2) in fromData.calendarLineList" class="class2" :key="item">
                <div v-if="!item.line_bool" style="margin-left: 3px" :class="!item.line_bool?'prompt data_style data_style1':''"
                     :style="maxHeight[index1]">产线未开
                </div>
                <div v-if="item.line_bool" class="data_style">
                  <div v-for="lineCnt in item.line_cnt" :key="lineCnt" class="data_style2">
                    <div class="data_style3">
                    <span v-if="lineCnt.dayShiftCnt" class="data_style4">&nbsp;白{{
                        lineCnt.dayShiftCnt
                      }}&nbsp;</span>
                      <span v-if="lineCnt.nightShiftCnt" class="data_style5">&nbsp;夜{{ lineCnt.nightShiftCnt }}&nbsp;</span>
                    </div>
                    <div>
                      <draggable :style="lineCnt.height" :class="lineCnt.class_line_name" :list="lineCnt.lineData"
                                 ghost-class="ghost" chosen-class="chosenClass" animation="300" :sort="true">
                        <template #item="{ element }">
                          <div v-if="JSON.stringify(element) !== '{}'"
                               style="background-color: #e7e7e7"
                               :style="element.is_material_shortage == false?'border-left: solid 3px rgb(103, 194, 58) !important':'border-left: solid 3px red !important;'"
                               class="item"
                               :class="element.class_name">
                            <el-row style="line-height: initial;">
                              <el-col style="height: 20px;line-height: 20px" :span="24">
                                <span>{{ element.wujian_name }}&nbsp;-&nbsp;</span>
                                <span>{{ element.scheduling_floor }}</span>
                              </el-col>
                              <div style="margin-top: -18px;margin-left: 92%;">
                                <span @click="materialDetailsClick(element,item.time,lineCnt)" class="cursor"
                                      style="font-size: 15px;"><el-icon><ElIconMoreFilled/></el-icon></span>
                              </div>
                            </el-row>
                            <div :class="element.is_material_shortage == false?'batchNoStyle1':'batchNoStyle2'"
                                 style="border-top: #909399 1px solid;border-bottom: #909399 1px solid;height: 20px;line-height: 20px">
                              <span>{{ element.batch_no }}</span>
                              <span style="color: #67c23a;margin-left: 35px;">{{ element.reality_num }}</span>
                              <span style="color: black">&nbsp;/&nbsp;</span>
                              <span style="color: #f56c6c">{{ element.plan_production_quantity }}&nbsp;</span>
                              <span style="color: black;">/&nbsp;{{ element.total_reality_num }}&nbsp;/&nbsp;</span>
                              <span style="color: #909399">{{ element.unit_num }}</span>
                            </div>
                            <div v-if="element.remark" style="height: auto;">备注：{{ element.remark }}</div>
                          </div>
                        </template>
                      </draggable>
                    </div>
                  </div>
                </div>
                <div style="margin-top: 3px;width: 224px;height: 30px;line-height: 30px;margin-left: 3px;text-align: center;">
                  <div class="plan_area" :style="getTop(index1,index2)" :class="fromData.class_name">
                    {{ item.plan_area + "（m²）" }}
                  </div>
                </div>
              </div>
            </div>
            <!--   计划合计面积-->
            <div style="display: flex">
              <div style="margin-top: 6px;width: 206px;height: 30px;line-height: 30px;text-align: center;margin-left: -3px;background-color: #40cc43" >
                <div class="plan_area" style="width: 206px;height: 30px;">
                  计划合计面积
                </div>
              </div>

              <div v-for="totalPlanArea in totalPlanAreaList" :key="totalPlanArea">
                <div  style="margin-top: 6px;width: 224px;height: 30px;text-align:center;line-height: 30px;margin-left: 3px;background-color: #40cc43">
                  <div style="width: 224px;" class="plan_area">{{ totalPlanArea + "（m²）"}}</div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <!--      无数据-->
        <div v-if="dataListBool" style="width:100%;height: 100px;line-height:100px;background-color: #e7e7e7;text-align: center;margin-top: 2px" class="border">
          <span style="font-size: 20px">未找到数据</span>
        </div>
      </div>
    </el-container>
  </div>
  <el-dialog title="计划详情" :close-on-click-modal="false"  :before-close="beforeClose"  v-model="materialDetailsBool" >
    <el-form :model="formWujianData" label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="物件番号：">
            <el-input v-model="formWujianData.wujian_id" disabled placeholder="物件番号" style="width: 90%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物件名称：">
            <el-input v-model="formWujianData.wujian_name" disabled placeholder="物件名称" style="width: 90%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="楼层信息：">
            <el-input v-model="formWujianData.scheduling_floor"  disabled placeholder="楼层信息" style="width: 90%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="批号：">
            <el-input v-model="formWujianData.batch_no" disabled placeholder="批号" style="width: 90%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="出荷日期：">
            <el-date-picker v-model="formWujianData.outbound_date" disabled type="date" placeholder="出荷日期" style="width: 90%"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="排产日期：">
            <el-date-picker v-model="formWujianData.production_scheduling_date" disabled type="date" placeholder="排产日期" style="width: 90%"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="排产产线：">
            <div v-if="!lineBool" class="border" style="width: 25px;height: 30px;line-height:30px;text-align: center;background-color: #0486fe;color: white;">{{formWujianData.lineCnt}}</div> <!--  白班-->
            <div v-if="lineBool" class="border" style="width: 25px;height: 30px;line-height:30px;text-align: center;background-color: #223342;color: white;">{{formWujianData.lineCnt}}</div> <!--  夜班-->
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实际数量：">
            <el-input-number disabled v-model="formWujianData.reality_num" placeholder="实际数量"  style="width: 90%;"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="单线日产量：">
            <el-input-number min="1" disabled v-model="formWujianData.line_production" placeholder="单线日产量" style="width: 90%;"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="本计划数：">
            <el-input-number disabled min="1"  v-model="formWujianData.plan_production_quantity" placeholder="本计划数" style="width: 90%"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="备注：">
            <el-input disabled v-model="formWujianData.remark" rows="5" type="textarea" placeholder="备注" style="width: 95%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-dialog>
</template>
<script>
import draggable from "vuedraggable";
import moment from "moment";
export default {
  name: "AssemblyPlan",
  components: {draggable},
  data() {
    return {
      startDate: '', //用来处理前段显示时间的
      endDate: '', //用来处理前段显示时间的
      startTime: '', //传后端的时间
      endTime: '', //传后端的时间
      assemblyEndTime:'',
      dataList:[],
      calendarLineList:[],
      totalPlanAreaList:[],
      wujian_border_color:'',
      week: [], //时间组件数据
      weekList: [], //一个星期的时间
      materialDetailsBool: false, //控制物料详情页面
      formWujianData: {},
      plan_production_quantity:'',
      remark: '',
      lineBool:false,//false表示白班 true表示夜班
      loading:false,
      loading1:false,
      dataListBool:false,
      maxHeight: {},//获取页面的最大高度
      maxLineHeight:{},
      cnt:0,
      cnt1:0,
      height1:[],
    }
  }, methods: {
    getTop(index1, index2) {
      if (!this.height1 || !this.height1[index1]) {
        return 0;
      }

      return this.height1[index1][index2]
    },
    beforeClose() {
      this.materialDetailsBool = false;
    },
    getPlanCalendarLineData(startTime,endTime) {
      this.totalPlanAreaList = []
      this.loading = true;
      let params = {startTime:startTime, endTime:endTime, weekList:this.weekList}
      this.$axios.post('mfg/assemblyPlan/getPlanCalendarLineData', params).then(response => {
        let res = response.data
        if (res.code !== 0){
          this.loading = false;
          return this.$message.error(res.message);
        }

        this.dataList = res.data.planCalendarLineList;
        if (this.dataList.length <= 0) {
          this.loading = false;
          this.dataListBool = true;
          return
        }
        this.calendarLineList = res.data.planCalendarLineList[0].calendarLineList;
        this.totalPlanAreaList = res.data.totalPlanAreaList;
        this.maxHeight = {};
        this.maxLineHeight = {};
        this.height1 = [];
        this.cnt = 0;
        this.cnt1 = 0;
        setTimeout(() => {
          for (let index = 0; index < res.data.planCalendarLineList.length; index++) {
            let widthBox1_1 = [];
            let widthBox2_2 = [];
            let widthBoxObject = {};
            let widthBox1 = document.getElementsByClassName('class2');
            let widthBox2 = document.getElementsByClassName('data_style');
            widthBoxObject.index = index;
            let a = 14;
            for (let i = 0; i < widthBox1.length; i++) {
              if (i < a * (index + 1) && i >= this.cnt) {
                widthBox1_1.push(widthBox1[i]);
                this.cnt += 1;
              }


            }
            widthBoxObject.widthBox1_1 = widthBox1_1;


            for (let i = 0; i < widthBox2.length; i++) {
              if (i < a * (index + 1) && i >= this.cnt1) {
                widthBox2_2.push(widthBox2[i]);
                this.cnt1 += 1;
              }
            }

            widthBoxObject.widthBox2_2 = widthBox2_2;
            //console.log("widthBoxObject==",widthBoxObject)
            this.getPlanAreaMarginTopHeight(widthBoxObject);
          }
          this.getAddEventListener();
        }, 300)
        this.loading = false;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
        this.loading = false;
      })
    },
    //物件计划详情
    materialDetailsClick(element,time,lineCnt) {
      this.materialDetailsBool = true;
      this.formWujianData = element;
      let cnt;
      if (lineCnt.dayShiftCnt) {
        cnt = lineCnt.dayShiftCnt;
        this.lineBool = false;
      } else {
        cnt = lineCnt.nightShiftCnt;
        this.lineBool = true;
      }

      this.formWujianData.form_className = lineCnt.class_line_name;
      this.formWujianData.lineCnt = cnt;
      this.formWujianData.scheduling_floor = element.scheduling_floor;
      let timeString = time.toString().substring(0,time.toString().length - 1);
      let timeList = timeString.toString().split("月");
      let month = timeList[0];
      let day = timeList[1];
      if (month < 10) {
        month = '0' + month;
      }

      if (day < 10) {
        day = '0' + day;
      }

      let date;
      //特殊处理跨年的
      if (this.startTime.substring(0,4) !== this.endTime.substring(0,4)) {
        if (parseInt(month) < 12) { //这是下一年
          date = this.endTime.substring(0,4) + '-' + month + '-' + day;
        } else {
          date = this.startTime.substring(0,4) + '-' + month + '-' + day;
        }
      } else {
        date = this.startTime.substring(0,4) + '-' + month + '-' + day;
      }
      this.formWujianData.production_scheduling_date = date;
      this.plan_production_quantity = this.formWujianData.plan_production_quantity;
      this.remark = this.formWujianData.remark;
    },
    //本周
    clickThisWeek() {
      let obj = this.getCurrWeekDays();
      this.formatTime(obj.startTime,obj.endTime);
    },
    //上周
    clickLastWeek() {
      let obj = this.getLastWeekDays(this.startTime, this.endTime);
      this.formatTime(obj.startTime,obj.endTime);
    },
    //下周
    clickNextWeek() {
      let obj = this.getBelowWeekDays(this.startTime, this.endTime);
      this.formatTime(obj.startTime,obj.endTime);
    },
    // 获取本周开始结束时间
    getCurrWeekDays() {
      let obj = {
        startTime: '',
        endTime: ''
      }

      let endDate = new Date(this.assemblyEndTime); // 结束日期
      obj.startTime = moment(moment().week(moment().week()).startOf('week').add(1, 'days').valueOf()).format('YYYY-MM-DD');
      obj.endTime = moment(endDate.valueOf()).format('YYYY-MM-DD');
      return obj
    },
    // 获取上一周的开始结束时间
    getLastWeekDays(startTime, endTime) {
      let obj = {
        startTime: '',
        endTime: ''
      }
      obj.startTime = moment(startTime).add(-7,'days').format('YYYY-MM-DD');
      obj.endTime = moment(endTime).add(-7,'days').format('YYYY-MM-DD');
      return obj
    },
    // 获取下一周的开始结束时间
    getBelowWeekDays(startTime, endTime) {
      let obj = {
        startTime: '',
        endTime: ''
      }
      obj.startTime = moment(startTime).add(7,'days').format('YYYY-MM-DD');
      obj.endTime = moment(endTime).add(7,'days').format('YYYY-MM-DD');
      return obj
    },
    //处理时间
    formatTime(startTime, endTime) {
      //console.log("startTime=",startTime)
      //console.log("endTime=",endTime)
      this.startTime = startTime;
      this.endTime = endTime;
      this.week = [];
      this.weekList = [];
      let startDate = moment(startTime).add(-1,'days');
      let endDate = moment(endTime);
      while (startDate.isBefore(endDate)) {
        startDate.add(1,'days');
        let date = moment(startDate).format('YYYY-MM-DD')
        let time = moment(date).format('MM') + "月" + moment(date).format('DD') + "日";
        this.weekList.push({time});
      }

      let weeks = ["一","二","三","四","五","六","日"]
      let cnt = 0;
      for (let i = 0; i < this.weekList.length; i++) {
        if (i === 7) {
          cnt = 0;
        }
        this.weekList[i]['week'] = "(" + weeks[cnt] + ")";
        cnt += 1;
      }

      this.startDate = moment(startTime).format('MM') + "-" + moment(startTime).format('DD');
      this.endDate = moment(endTime).format('MM') + "-" + moment(endTime).format('DD');
      this.week.push(this.startDate);
      this.week.push(this.endDate);
      this.getPlanCalendarLineData(startTime, endTime);
    },
    getAssemblyEndTime(){
      let startTime = moment(moment().week(moment().week()).startOf('week').add(1, 'days').valueOf()).format('YYYY-MM-DD');
      let endTime = moment(moment().week(moment().week()).endOf('week').add(8, 'days').valueOf()).format('YYYY-MM-DD');
      let params = {startTime: startTime, endTime: endTime};
      this.$axios.post('mfg/assemblyProduction/getAssemblyEndTime',params).then(response => {
        let res = response.data
        if (res.code !== 0){
          return this.$message.error("组立最后排产时间为空");
        }

        this.assemblyEndTime = res.data;
        let obj = this.getCurrWeekDays();
        this.formatTime(obj.startTime,obj.endTime);
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    getPlanAreaMarginTopHeight(widthBoxObject) {
      let index = widthBoxObject.index;
      let height2 = {};
      let h_max1 = 0;
      let widthBox1 = widthBoxObject.widthBox1_1;

      let h_max2 = 0;
      let widthBox2 = widthBoxObject.widthBox2_2;

      for (let y = 0; y < widthBox1.length; y++) {
        if (!this.dataList[index].calendarLineList[y].line_bool) {
          height2[y] = "margin-top: 0px;";
        } else {
          h_max1 = widthBox1[y].clientHeight - 35;
          h_max2 = widthBox2[y].clientHeight === 0?-5:widthBox2[y].clientHeight;
          height2[y] = "margin-top: " + (h_max1 - h_max2) + "px;";
        }
      }

      this.height1.push(height2)

      let h_max3 = 0;
      for (let y = 0; y < widthBox2.length; y++) {
        if (h_max3 < widthBox2[y].clientHeight) {
          h_max3 = widthBox2[y].clientHeight;
        }
      }

      this.maxHeight[index] = "height: "+(h_max3)+"px;";
      this.maxLineHeight[index] = "line-height: "+(h_max3)+"px;height: "+(h_max3)+"px";
      // console.log("height1=======", this.maxHeight)
      // console.log("height1=======", this.maxLineHeight)
      //console.log("height1=======", this.height1)
    },
    exportData() {
      this.loading1 = true;
      console.log("exportData=======")
      let params = {startTime:this.startTime, endTime:this.endTime, dataList:this.dataList,totalPlanAreaList:this.totalPlanAreaList}
      this.$axios.post('mfg/assemblyPlan/exportData', params).then(response => {
        this.loading1 = false;
        let res = response.data
        if (res.code !== 0){
          this.loading1 = false;
          return this.$message.error(res.message);
        }

        const url = res.data.data.url;
        const originalName = res.data.data.originalName;
        if (url) {
          const link = document.createElement('a');
          link.href = url;
          link.download = originalName || '' // 下载文件的名字
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
        }

        this.$message.success("导出成功");
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
        this.loading1 = false;
      })
    },
    getAddEventListener() {
      // 获取需要动态改变宽度的 div
      const dynamicDiv = document.getElementById('dynamicDiv');
      const dynamicDiv1 = document.getElementById('dynamicDiv1');
      let width = dynamicDiv1.offsetWidth;
      // 初始化上一次的 scrollLeft 值
      let lastScrollLeft = 0;
      // 监听窗口的滚动事件
      dynamicDiv.addEventListener('scroll', function() {
        // 获取当前的 scrollLeft 值
        const currentScrollLeft = dynamicDiv.scrollLeft;
        // 判断滚动方向
        if (currentScrollLeft > lastScrollLeft) {
          console.log('Scrolling right');
        } else if (currentScrollLeft < lastScrollLeft) {
          console.log('Scrolling left');
        }

        // 更新 lastScrollLeft 值
        lastScrollLeft = currentScrollLeft;
        // 设置新的宽度
        dynamicDiv1.style.width = (width + lastScrollLeft) + 'px';
      });
    }
  },created() {
    this.getAssemblyEndTime();
  },mounted(){

  }
}
</script>

<style scoped>
.border {
  border:rgb(216, 220, 230) 2px solid;
}

.color {
  background-color: #e7e7e7;
}

.center {
  text-align: center;
  line-height: 32px;
}

.cursor {
  cursor: pointer;
}

/*一下是拖拽样式*/
.item {
  font-size: 14px;
  color: black;
  margin-top: 3px;
  height: 100%;
  text-align: center;
  background-color:  #e7e7e7;
}

.chosenClass {
  font-size: 14px;
  font-weight: bold;
}

/*div样式*/
.week {
  border: #909399 0 solid;background-color: white; color: rgb(4, 134, 254);
}

.data_style {
  width:224px;
  height: auto;
  margin-left: 3px;
}

.data_style1 {
  width:224px;
  height: auto;
  background-color: #e7e7e7;
  margin-top: 5px;
  border:rgb(216, 220, 230) 2px solid;
}

.data_style2 {
  margin-top: 5px;
  border:rgb(216, 220, 230) 2px solid;
}

.data_style3 {
  width:100%;
  background-color: rgb(228, 231, 237);
  color: white;
  text-align: center;
  height: 30px;
  line-height: 30px;
}

.data_style4 {
  background-color: #0478e4;
  font-size: 14px;
}

.data_style5 {
  background-color: black;
  margin-left: 2px;
  font-size: 14px;
}

/*动态样式*/

.batchNoStyle1 {
  color: #0478e4
}

.batchNoStyle2 {
  color: red
}

.scrollbar::-webkit-scrollbar{
  display: none;
}

.prompt {
  color:rgba(0, 0, 0, 0.2);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}


.el-select .el-input {
  display: flex;
  height: 40px;
}

.plan_area {
  color: whitesmoke;
  font-size: 16px;
}

.wujian_border_color1 {
  background-color: #0478e4;
  border: solid 2px #0478e4 !important
}

.wujian_border_color2 {
  background-color: #3BA272;
  border: solid 2px #3BA272 !important
}

.wujian_border_color3 {
  background-color: #9A60B4;
  border: solid 2px #9A60B4 !important
}

.wujian_border_color4 {
  background-color: #FAC858;
  border: solid 2px #FAC858 !important
}

.wujian_border_color5 {
  background-color: #91CC75;
  border: solid 2px #91CC75 !important
}

.wujian_border_color6 {
  background-color: #73C0DE;
  border: solid 2px #73C0DE !important
}

.wujian_border_color7 {
  background-color: #EE6666;
  border: solid 2px #EE6666 !important
}

.wujian_border_color8 {
  background-color: #9A60B4;
  border: solid 2px #9A60B4 !important
}

.wujian_border_color9 {
  background-color: #1ba974;
  border: solid 2px #1ba974 !important
}

.wujian_border_color10 {
  background-color: #818049;
  border: solid 2px #818049 !important
}

</style>